import { ConstructorAnalytics } from '~/src/features/tariffBuilder/analytics';
import { EAction } from '~/src/features/tariffBuilder/constants/actions';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { IAction } from '~/src/store';

type TAddEntityArgs = {
    entity: EEntity,
    group: string,
    key: number,
    groupTitle?: string,
    itemTitle?: string,
}

const addTvEntity = (entityData: TAddEntityArgs, analytics: ConstructorAnalytics): IAction<EAction.AddTvEntity, TAddEntityArgs> => {
    const { entity, group, key, groupTitle = '', itemTitle = '' } = entityData;
    const label = group === 'base' ? 'Базовый пакет каналов' : `package:${groupTitle}|channel:${itemTitle}|`;

    analytics.clickedTvChannelCheckBox(label);

    return ({
        type: EAction.AddTvEntity,
        payload: {
            entity,
            group,
            key,
        },
    });
};

export default addTvEntity;
